<template>
  <div>
    <v-breadcrumbs :items="breadcrumbs" class="breadcrumbs" />
    <heading>{{ periodTitle }}</heading>
    <environmentalReportTable />
  </div>
</template>

<script>
import environmentalReportTable from "@/views/environmentalReport/environmentalReportTable.vue";
import i18n from "../../i18n";
import { monthLabel } from "../../utils/monthLabel";

export default {
  name: "environmentalReport",
  components: { environmentalReportTable },
  computed: {
    year() {
      return this.$route.params.year;
    },
    month() {
      return this.$route.params.month;
    },
    periodTitle() {
      return `${monthLabel(this.month, this.$i18n.locale)} ${this.year}`;
    },
    breadcrumbs() {
      return [
        {
          text: i18n.t("sidebar.environmentalReports"),
          disabled: false,
          href: "/app/environmentalReports",
        },
        {
          text: this.year,
          disabled: false,
          href: `/app/environmentalReports/year/${this.year}`,
        },
        {
          text: monthLabel(this.month, this.$i18n.locale),
          disabled: true,
        },
      ];
    },
  },
};
</script>
